import { useSelector } from 'react-redux';

import { Helpers } from '../core/src/helpers';
const { memoize } = Helpers;

const deviceSelector = memoize(
    ui => {
        return {
            device: ui.device,
            width: ui.width,
            height: ui.height,
            customBreakpoints: ui.customBreakpoints,
        };
    },
    (ui, deps) => {
        const { device, width, height } = ui;
        //memoize based on the dependency list values
        if (deps && deps.length > 0) {
            return deps.reduce((r, k) => {
                return r + ui[k];
            }, '');
        }
        //otherwise default memoize on device with and height
        return `${device}${width}${height}`;
    }
);

/**
 * Returns the device info state
 * @name useCartState
 * @returns {cartInfo}
 */
export default function useDeviceInfo(deps) {
    return useSelector(state => deviceSelector(state.ui, deps));
}
